Oskari.bundle_manager.registerDynamic('announcements', function() {return import(/* webpackChunkName: "chunk_announcements" */ 'oskari-loader!oskari-frontend/packages/framework/bundle/announcements/bundle.js');});
